module.exports = __webpack_public_path__ + "static/media/clock.0686f8b3.png";